// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
import "babel-polyfill"

import Vuex from 'vuex'
import axios from 'axios'

import Base64 from './request/base64' 

import httpBase from './request/http.vue'
// import './../static/rem'

// import echarts from 'echarts'

import 'lib-flexible'
// axios.defaults.headers.post["Content-type"]="application/x-www-form-urlencoded"
Vue.prototype.$http=axios
Vue.config.productionTip = false

Vue.prototype.oUrl = httpBase

// Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.use(animated)
Vue.use(Vuex)

Vue.prototype.$Base64 = Base64;
Vue.prototype.oUrl = httpBase
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js